import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Tier Map List
export const fetchTierMap = createAsyncThunk(
  "tierMap/fetchTierMap",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/location/panel/TierMap");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Tier Map
export const addTierMap = createAsyncThunk(
  "tierMap/addTierMap",
  async (newTierMapData, { rejectWithValue }) => {
    try {
      const response = await api.post("/location/panel/TierMap", newTierMapData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Tier Map
export const updateTierMap = createAsyncThunk(
  "tierMap/updateTierMap",
  async (tierMapData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/location/panel/TierMap", tierMapData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Tier Map Slice
const tierMapSlice = createSlice({
  name: "tierMap",
  initialState: {
    tierMapList: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchTierMap.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchTierMap.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.tierMapList = action.payload;
      })
      .addCase(fetchTierMap.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Add
      .addCase(addTierMap.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addTierMap.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addTierMap.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Update
      .addCase(updateTierMap.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateTierMap.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateTierMap.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = tierMapSlice.actions;
export default tierMapSlice.reducer;
